/* eslint-disable */
/**
 * This file was generated by 'vite-plugin-kit-routes'
 *
 *      >> DO NOT EDIT THIS FILE MANUALLY <<
 */

/**
 * PAGES
 */
const PAGES = {
  "/[accountId]": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}`
  },
  "/[accountId]/checkout": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/checkout`
  },
  "/[accountId]/checkout/stripe": (params: { accountId: (string | number), price?: (string), returnUrl?: (string), type?: (string), freeTrial?: (boolean) }) => {
    return `/${params['accountId']}/checkout/stripe${appendSp({ 'price': params['price'], 'returnUrl': params['returnUrl'], 'type': params['type'], 'freeTrial': params['freeTrial'] })}`
  },
  "/[accountId]/select-plan": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/select-plan`
  },
  "/[accountId]/success": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/success`
  },
  "/[accountId]/success/stripe": (params: { accountId: (string | number), session_id?: (string), price?: (string) }) => {
    return `/${params['accountId']}/success/stripe${appendSp({ 'session_id': params['session_id'], 'price': params['price'] })}`
  },
  "/[accountId]/activity/devices": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/activity/devices`
  },
  "/[accountId]/activity/dns": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/activity/dns`
  },
  "/[accountId]/activity/dns/recent": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/activity/dns/recent`
  },
  "/[accountId]/content-policy": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy`
  },
  "/[accountId]/content-policy/connect": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect`
  },
  "/[accountId]/content-policy/connect/android": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/android`
  },
  "/[accountId]/content-policy/connect/android/app": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/android/app`
  },
  "/[accountId]/content-policy/connect/android/certificate": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/android/certificate`
  },
  "/[accountId]/content-policy/connect/ios": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/ios`
  },
  "/[accountId]/content-policy/connect/ios/app": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/ios/app`
  },
  "/[accountId]/content-policy/connect/ios/certificate": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/ios/certificate`
  },
  "/[accountId]/content-policy/connect/mac": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/mac`
  },
  "/[accountId]/content-policy/connect/mac/app": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/mac/app`
  },
  "/[accountId]/content-policy/connect/mac/certificate": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/mac/certificate`
  },
  "/[accountId]/content-policy/connect/router": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/router`
  },
  "/[accountId]/content-policy/connect/windows": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/windows`
  },
  "/[accountId]/content-policy/connect/windows/app": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/windows/app`
  },
  "/[accountId]/content-policy/connect/windows/certificate": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/connect/windows/certificate`
  },
  "/[accountId]/content-policy/debug": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/debug`
  },
  "/[accountId]/content-policy/rules/[ruleId]": (params: { accountId: (string | number), ruleId: (string | number), focus?: (string), tab?: (string) }) => {
    return `/${params['accountId']}/content-policy/rules/${params['ruleId']}${appendSp({ 'focus': params['focus'], 'tab': params['tab'] })}`
  },
  "/[accountId]/content-policy/rules/[ruleId]/history": (params: { accountId: (string | number), ruleId: (string | number) }) => {
    return `/${params['accountId']}/content-policy/rules/${params['ruleId']}/history`
  },
  "/[accountId]/settings/cloudflare": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare`
  },
  "/[accountId]/settings/cloudflare/agent": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/agent`
  },
  "/[accountId]/settings/cloudflare/certificates": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/certificates`
  },
  "/[accountId]/settings/cloudflare/debug": (params: { accountId: (string | number), auto?: (boolean) }) => {
    return `/${params['accountId']}/settings/cloudflare/debug${appendSp({ 'auto': params['auto'] })}`
  },
  "/[accountId]/settings/cloudflare/networks": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/networks`
  },
  "/[accountId]/settings/cloudflare/networks/location": (params: { accountId: (string | number), id?: (string) }) => {
    return `/${params['accountId']}/settings/cloudflare/networks/location${appendSp({ 'id': params['id'] })}`
  },
  "/[accountId]/settings/cloudflare/traffic": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/traffic`
  },
  "/[accountId]/settings/cloudflare/sync": (params: { accountId: (string | number), accountId?: (string), auto?: (boolean), redirect?: (boolean), redirectUrl?: (string) }) => {
    return `/${params['accountId']}/settings/cloudflare/sync${appendSp({ 'accountId': params['accountId'], 'auto': params['auto'], 'redirect': params['redirect'], 'redirectUrl': params['redirectUrl'] })}`
  },
  "/[accountId]/activity": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/activity`
  },
  "/[accountId]/activity/history": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/activity/history`
  },
  "/[accountId]/device-config": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/device-config`
  },
  "/[accountId]/device-config/[configId]": (params: { accountId: (string | number), configId: (string | number), showTutorial?: (boolean) }) => {
    return `/${params['accountId']}/device-config/${params['configId']}${appendSp({ 'showTutorial': params['showTutorial'] })}`
  },
  "/[accountId]/settings": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings`
  },
  "/[accountId]/settings/account": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/account`
  },
  "/[accountId]/settings/billing": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/billing`
  },
  "/[accountId]/settings/cloudflare/connect": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/connect`
  },
  "/[accountId]/settings/members": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/members`
  },
  "/[accountId]/settings/profile": (params: { accountId: (string | number), tab?: ("general" | "locking-preferences") }) => {
    return `/${params['accountId']}/settings/profile${appendSp({ 'tab': params['tab'] })}`
  },
  "/[accountId]/setup": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/setup`
  },
  "/[accountId]/setup/ios/prevent-bypass": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/setup/ios/prevent-bypass`
  },
  "/[accountId]/setup/ios/prevent-bypass/supervised": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/setup/ios/prevent-bypass/supervised`
  },
  "/[accountId]/setup/mac/prevent-bypass": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/setup/mac/prevent-bypass`
  },
  "/[accountId]/tools": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools`
  },
  "/[accountId]/tools/ios": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/ios`
  },
  "/[accountId]/tools/ios/app-management": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/ios/app-management`
  },
  "/[accountId]/tools/ios/app-management/allowlist": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/ios/app-management/allowlist`
  },
  "/[accountId]/tools/ios/app-management/blocklist": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/ios/app-management/blocklist`
  },
  "/[accountId]/tools/ios/config-presets": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/ios/config-presets`
  },
  "/[accountId]/tools/mac": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/mac`
  },
  "/[accountId]/tools/mac/config-presets": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/mac/config-presets`
  },
  "/[accountId]/tools/mac/warp-enforcer": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/mac/warp-enforcer`
  },
  "/[accountId]/tools/windows": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/windows`
  },
  "/[accountId]/tools/windows/content-policy-enforcer": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/tools/windows/content-policy-enforcer`
  },
  "/create-account": `/create-account`,
  "/home": `/home`,
  "/profile": `/profile`,
  "/profile/accounts": `/profile/accounts`,
  "/profile/invites": `/profile/invites`,
  "/profile/invites/[inviteId]": (params: { inviteId: (string | number) }) => {
    return `/profile/invites/${params['inviteId']}`
  },
  "/": `/`,
  "/guides": `/guides`,
  "/guides/[slug]": (params: { slug: (string | number), referer?: (string) }) => {
    return `/guides/${params['slug']}${appendSp({ 'referer': params['referer'] })}`
  },
  "/tutorials": `/tutorials`,
  "/tutorials/[slug]": (params: { slug: (string | number) }) => {
    return `/tutorials/${params['slug']}`
  },
  "/login": `/login`,
  "/sentry/client": `/sentry/client`,
  "/sentry/server": `/sentry/server`
}

/**
 * SERVERS
 */
const SERVERS = {
  "POST /[accountId]/cloudflare/tokens": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/cloudflare/tokens`
  },
  "POST /cloudflare/pull/apps": `/cloudflare/pull/apps`,
  "POST /cloudflare/pull/categories": `/cloudflare/pull/categories`,
  "POST /debug": `/debug`,
  "POST /debug/sentry": `/debug/sentry`,
  "POST /debug/zenstack": `/debug/zenstack`,
  "POST /stripe/pull/catalog": `/stripe/pull/catalog`,
  "GET /[accountId]/api/cloudflare/account": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/account`
  },
  "POST /[accountId]/api/cloudflare/account/debug": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/account/debug`
  },
  "POST /[accountId]/api/cloudflare/account/tokens": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/account/tokens`
  },
  "POST /[accountId]/api/cloudflare/enable-access": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/enable-access`
  },
  "POST /[accountId]/api/cloudflare/enable-block-page": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/enable-block-page`
  },
  "GET /[accountId]/api/cloudflare/intel/domain": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/intel/domain`
  },
  "GET /[accountId]/api/cloudflare/locations": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/locations`
  },
  "GET /[accountId]/api/cloudflare/pull": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull`
  },
  "GET /[accountId]/api/cloudflare/pull/locations": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull/locations`
  },
  "GET /[accountId]/api/cloudflare/pull/locations/[locationId]": (params: { accountId: (string | number), locationId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull/locations/${params['locationId']}`
  },
  "GET /[accountId]/api/cloudflare/pull/rules": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull/rules`
  },
  "GET /[accountId]/api/cloudflare/pull/rules/[ruleId]": (params: { accountId: (string | number), ruleId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull/rules/${params['ruleId']}`
  },
  "GET /[accountId]/api/cloudflare/pull/settings": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/pull/settings`
  },
  "GET /[accountId]/api/cloudflare/push/rules": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/push/rules`
  },
  "GET /[accountId]/api/cloudflare/push/rules/[ruleId]": (params: { accountId: (string | number), ruleId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/push/rules/${params['ruleId']}`
  },
  "GET /[accountId]/api/cloudflare/push/settings": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/push/settings`
  },
  "POST /[accountId]/api/cloudflare/rules": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/rules`
  },
  "POST /[accountId]/api/auth/email": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/auth/email`
  },
  "GET /[accountId]/api/cloudflare/accounts": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/accounts`
  },
  "POST /[accountId]/api/cloudflare/accounts": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/api/cloudflare/accounts`
  },
  "GET /api/accounts/[accountId]/cloudflare-sdk/gateway/activity/devices": (params: { accountId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/activity/devices`
  },
  "GET /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates": (params: { accountId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates`
  },
  "POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates": (params: { accountId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates`
  },
  "GET /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates/${params['certificateId']}`
  },
  "DELETE /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates/${params['certificateId']}`
  },
  "POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/activate": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates/${params['certificateId']}/activate`
  },
  "POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/deactivate": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates/${params['certificateId']}/deactivate`
  },
  "POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/turn-on": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/api/accounts/${params['accountId']}/cloudflare-sdk/gateway/certificates/${params['certificateId']}/turn-on`
  },
  "POST /api/cloudflare-sdk/graphql": `/api/cloudflare-sdk/graphql`,
  "GET /api/itunes/search": `/api/itunes/search`,
  "POST /api/profile/lock": `/api/profile/lock`,
  "POST /api/profile/locking-mechanism/encrypt-password": `/api/profile/locking-mechanism/encrypt-password`,
  "POST /api/profile/pin-request": `/api/profile/pin-request`,
  "POST /api/profile/pin-request/verify": `/api/profile/pin-request/verify`,
  "POST /api/profile/secondary-email": `/api/profile/secondary-email`,
  "POST /api/profile/secondary-email/verify": `/api/profile/secondary-email/verify`,
  "POST /api/profile/unlock": `/api/profile/unlock`,
  "POST /api/profile/validate/[mechanismType]": (params: { mechanismType: (string | number) }) => {
    return `/api/profile/validate/${params['mechanismType']}`
  },
  "GET /api/device-config/download/[deviceConfigId]": (params: { deviceConfigId: (string | number), responseType?: (string), action?: (string), timestamp?: (number) }) => {
    return `/api/device-config/download/${params['deviceConfigId']}${appendSp({ 'responseType': params['responseType'], 'action': params['action'], 'timestamp': params['timestamp'] })}`
  },
  "prerender /api/device-config/registry/[platform]/[osId]/[category].json": (params: { platform: (string | number), osId: (string | number), category: (string | number) }) => {
    return `/api/device-config/registry/${params['platform']}/${params['osId']}/${params['category']}.json`
  },
  "entries /api/device-config/registry/[platform]/[osId]/[category].json": (params: { platform: (string | number), osId: (string | number), category: (string | number) }) => {
    return `/api/device-config/registry/${params['platform']}/${params['osId']}/${params['category']}.json`
  },
  "GET /api/device-config/registry/[platform]/[osId]/[category].json": (params: { platform: (string | number), osId: (string | number), category: (string | number) }) => {
    return `/api/device-config/registry/${params['platform']}/${params['osId']}/${params['category']}.json`
  },
  "GET /auth/callback": `/auth/callback`,
  "GET /auth/confirm": `/auth/confirm`,
  "GET /download/[accountId]/cloudflare/certificates": (params: { accountId: (string | number) }) => {
    return `/download/${params['accountId']}/cloudflare/certificates`
  },
  "GET /download/[accountId]/cloudflare/certificates/[certificateId]": (params: { accountId: (string | number), certificateId: (string | number) }) => {
    return `/download/${params['accountId']}/cloudflare/certificates/${params['certificateId']}`
  },
  "GET /download/config/ios/presets": `/download/config/ios/presets`,
  "GET /download/config/macos/presets": `/download/config/macos/presets`,
  "GET /logout": `/logout`,
  "POST /qstash/[messageType]": (params: { messageType: (string | number) }) => {
    return `/qstash/${params['messageType']}`
  },
  "prerender /static-cache/dns-app/traffic-log-filter.json": `/static-cache/dns-app/traffic-log-filter.json`,
  "GET /static-cache/dns-app/traffic-log-filter.json": `/static-cache/dns-app/traffic-log-filter.json`,
  "prerender /static-cache/dns-content-category/traffic-log-filter.json": `/static-cache/dns-content-category/traffic-log-filter.json`,
  "GET /static-cache/dns-content-category/traffic-log-filter.json": `/static-cache/dns-content-category/traffic-log-filter.json`,
  "POST /webhooks/stripe": `/webhooks/stripe`,
  "POST /webhooks/supabase": `/webhooks/supabase`,
  "GET /webhooks/supabase": `/webhooks/supabase`,
  "POST /webhooks/supabase/cloudflare/locations": `/webhooks/supabase/cloudflare/locations`,
  "GET /webhooks/supabase/cloudflare/locations": `/webhooks/supabase/cloudflare/locations`,
  "POST /webhooks/supabase/events": `/webhooks/supabase/events`,
  "GET /webhooks/supabase/events": `/webhooks/supabase/events`
}

/**
 * ACTIONS
 */
const ACTIONS = {
  "update /[accountId]/settings/cloudflare": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare?/update`
  },
  "create /[accountId]/settings/cloudflare/networks/location": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/networks/location?/create`
  },
  "update /[accountId]/settings/cloudflare/networks/location": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/networks/location?/update`
  },
  "delete /[accountId]/settings/cloudflare/networks/location": (params: { accountId: (string | number) }) => {
    return `/${params['accountId']}/settings/cloudflare/networks/location?/delete`
  },
  "accept /profile/invites/[inviteId]": (params: { inviteId: (string | number) }) => {
    return `/profile/invites/${params['inviteId']}?/accept`
  }
}

/**
 * LINKS
 */
const LINKS = {
  "profileLocking": `https://help.techlockdown.com/hc/en-us/articles/33594743294740-Profile-Locking`,
  "deviceSetup": `https://help.techlockdown.com/hc/en-us/articles/33681135635860-Setting-up-devices-based-on-Tech-Lockdown-recommendations`,
  "installConfigFilesOnIOS": `https://help.techlockdown.com/hc/en-us/articles/33611480393876-Install-Config-Files-on-iOS`,
  "installConfigFilesOnMac": `https://help.techlockdown.com/hc/en-us/articles/33612272894868-Install-Config-Profiles-on-Mac`,
  "uninstallConfigFilesOnMac": `https://help.techlockdown.com/hc/en-us/articles/33612674763284-Uninstall-Config-Profiles-on-Mac`,
  "uninstallConfigFilesOnIOS": `https://help.techlockdown.com/hc/en-us/articles/33611866456724-Uninstall-Config-Files-on-iOS`,
  "deviceConfigReleaseBlog": `https://techlockdown.com/blog/april-2025-device-config-generator`,
  "freeGuideAppleShortcuts": `https://techlockdown.com/guides/apple-shortcuts-automations-ios`
}

type ParamValue = string | number | undefined

/**
 * Append search params to a string
 */
export const appendSp = (
  sp?: Record<string, ParamValue | ParamValue[]>,
  prefix: '?' | '&' = '?',
) => {
  if (sp === undefined) return ''

  const params = new URLSearchParams()
  const append = (n: string, v: ParamValue) => {
    if (v !== undefined) {
      params.append(n, String(v))
    }
  }

  let anchor = ''
  for (const [name, val] of Object.entries(sp)) {
    if (name === '__KIT_ROUTES_ANCHOR__' && val !== undefined) {
      anchor = `#${val}`
      continue
    }
    if (Array.isArray(val)) {
      for (const v of val) {
        append(name, v)
      }
    } else {
      append(name, val)
    }
  }

  const formatted = params.toString()
  if (formatted || anchor) {
    return `${prefix}${formatted}${anchor}`.replace('?#', '#')
  }
  return ''
}

/**
 * get the current search params
 * 
 * Could be use like this:
 * ```
 * route("/cities", { page: 2 }, { ...currentSP() })
 * ```
 */ 
export const currentSp = () => {
  const params = new URLSearchParams(window.location.search)
  const record: Record<string, string> = {}
  for (const [key, value] of params.entries()) {
    record[key] = value
  }
  return record
}

// route function helpers
type NonFunctionKeys<T> = { [K in keyof T]: T[K] extends Function ? never : K }[keyof T]
type FunctionKeys<T> = { [K in keyof T]: T[K] extends Function ? K : never }[keyof T]
type FunctionParams<T> = T extends (...args: infer P) => any ? P : never

const AllObjs = { ...PAGES, ...ACTIONS, ...SERVERS, ...LINKS }
type AllTypes = typeof AllObjs

export type Routes = keyof AllTypes extends `${string}/${infer Route}` ? `/${Route}` : keyof AllTypes
export const routes = [
	...new Set(Object.keys(AllObjs).map((route) => /^\/.*|[^ ]?\/.*$/.exec(route)?.[0] ?? route)),
] as Routes[]

/**
 * To be used like this: 
 * ```ts
 * import { route } from './ROUTES'
 * 
 * route('site_id', { id: 1 })
 * ```
 */
export function route<T extends FunctionKeys<AllTypes>>(key: T, ...params: FunctionParams<AllTypes[T]>): string
export function route<T extends NonFunctionKeys<AllTypes>>(key: T): string
export function route<T extends keyof AllTypes>(key: T, ...params: any[]): string {
  if (AllObjs[key] as any instanceof Function) {
    const element = (AllObjs as any)[key] as (...args: any[]) => string
    return element(...params)
  } else {
    return AllObjs[key] as string
  }
}

/**
* Add this type as a generic of the vite plugin `kitRoutes<KIT_ROUTES>`.
*
* Full example:
* ```ts
* import type { KIT_ROUTES } from '$lib/ROUTES'
* import { kitRoutes } from 'vite-plugin-kit-routes'
*
* kitRoutes<KIT_ROUTES>({
*  PAGES: {
*    // here, key of object will be typed!
*  }
* })
* ```
*/
export type KIT_ROUTES = {
  PAGES: { '/[accountId]': 'accountId', '/[accountId]/checkout': 'accountId', '/[accountId]/checkout/stripe': 'accountId', '/[accountId]/select-plan': 'accountId', '/[accountId]/success': 'accountId', '/[accountId]/success/stripe': 'accountId', '/[accountId]/activity/devices': 'accountId', '/[accountId]/activity/dns': 'accountId', '/[accountId]/activity/dns/recent': 'accountId', '/[accountId]/content-policy': 'accountId', '/[accountId]/content-policy/connect': 'accountId', '/[accountId]/content-policy/connect/android': 'accountId', '/[accountId]/content-policy/connect/android/app': 'accountId', '/[accountId]/content-policy/connect/android/certificate': 'accountId', '/[accountId]/content-policy/connect/ios': 'accountId', '/[accountId]/content-policy/connect/ios/app': 'accountId', '/[accountId]/content-policy/connect/ios/certificate': 'accountId', '/[accountId]/content-policy/connect/mac': 'accountId', '/[accountId]/content-policy/connect/mac/app': 'accountId', '/[accountId]/content-policy/connect/mac/certificate': 'accountId', '/[accountId]/content-policy/connect/router': 'accountId', '/[accountId]/content-policy/connect/windows': 'accountId', '/[accountId]/content-policy/connect/windows/app': 'accountId', '/[accountId]/content-policy/connect/windows/certificate': 'accountId', '/[accountId]/content-policy/debug': 'accountId', '/[accountId]/content-policy/rules/[ruleId]': 'accountId' | 'ruleId', '/[accountId]/content-policy/rules/[ruleId]/history': 'accountId' | 'ruleId', '/[accountId]/settings/cloudflare': 'accountId', '/[accountId]/settings/cloudflare/agent': 'accountId', '/[accountId]/settings/cloudflare/certificates': 'accountId', '/[accountId]/settings/cloudflare/debug': 'accountId', '/[accountId]/settings/cloudflare/networks': 'accountId', '/[accountId]/settings/cloudflare/networks/location': 'accountId', '/[accountId]/settings/cloudflare/traffic': 'accountId', '/[accountId]/settings/cloudflare/sync': 'accountId', '/[accountId]/activity': 'accountId', '/[accountId]/activity/history': 'accountId', '/[accountId]/device-config': 'accountId', '/[accountId]/device-config/[configId]': 'accountId' | 'configId', '/[accountId]/settings': 'accountId', '/[accountId]/settings/account': 'accountId', '/[accountId]/settings/billing': 'accountId', '/[accountId]/settings/cloudflare/connect': 'accountId', '/[accountId]/settings/members': 'accountId', '/[accountId]/settings/profile': 'accountId', '/[accountId]/setup': 'accountId', '/[accountId]/setup/ios/prevent-bypass': 'accountId', '/[accountId]/setup/ios/prevent-bypass/supervised': 'accountId', '/[accountId]/setup/mac/prevent-bypass': 'accountId', '/[accountId]/tools': 'accountId', '/[accountId]/tools/ios': 'accountId', '/[accountId]/tools/ios/app-management': 'accountId', '/[accountId]/tools/ios/app-management/allowlist': 'accountId', '/[accountId]/tools/ios/app-management/blocklist': 'accountId', '/[accountId]/tools/ios/config-presets': 'accountId', '/[accountId]/tools/mac': 'accountId', '/[accountId]/tools/mac/config-presets': 'accountId', '/[accountId]/tools/mac/warp-enforcer': 'accountId', '/[accountId]/tools/windows': 'accountId', '/[accountId]/tools/windows/content-policy-enforcer': 'accountId', '/create-account': never, '/home': never, '/profile': never, '/profile/accounts': never, '/profile/invites': never, '/profile/invites/[inviteId]': 'inviteId', '/': never, '/guides': never, '/guides/[slug]': 'slug', '/tutorials': never, '/tutorials/[slug]': 'slug', '/login': never, '/sentry/client': never, '/sentry/server': never }
  SERVERS: { 'POST /[accountId]/cloudflare/tokens': 'accountId', 'POST /cloudflare/pull/apps': never, 'POST /cloudflare/pull/categories': never, 'POST /debug': never, 'POST /debug/sentry': never, 'POST /debug/zenstack': never, 'POST /stripe/pull/catalog': never, 'GET /[accountId]/api/cloudflare/account': 'accountId', 'POST /[accountId]/api/cloudflare/account/debug': 'accountId', 'POST /[accountId]/api/cloudflare/account/tokens': 'accountId', 'POST /[accountId]/api/cloudflare/enable-access': 'accountId', 'POST /[accountId]/api/cloudflare/enable-block-page': 'accountId', 'GET /[accountId]/api/cloudflare/intel/domain': 'accountId', 'GET /[accountId]/api/cloudflare/locations': 'accountId', 'GET /[accountId]/api/cloudflare/pull': 'accountId', 'GET /[accountId]/api/cloudflare/pull/locations': 'accountId', 'GET /[accountId]/api/cloudflare/pull/locations/[locationId]': 'accountId' | 'locationId', 'GET /[accountId]/api/cloudflare/pull/rules': 'accountId', 'GET /[accountId]/api/cloudflare/pull/rules/[ruleId]': 'accountId' | 'ruleId', 'GET /[accountId]/api/cloudflare/pull/settings': 'accountId', 'GET /[accountId]/api/cloudflare/push/rules': 'accountId', 'GET /[accountId]/api/cloudflare/push/rules/[ruleId]': 'accountId' | 'ruleId', 'GET /[accountId]/api/cloudflare/push/settings': 'accountId', 'POST /[accountId]/api/cloudflare/rules': 'accountId', 'POST /[accountId]/api/auth/email': 'accountId', 'GET /[accountId]/api/cloudflare/accounts': 'accountId', 'POST /[accountId]/api/cloudflare/accounts': 'accountId', 'GET /api/accounts/[accountId]/cloudflare-sdk/gateway/activity/devices': 'accountId', 'GET /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates': 'accountId', 'POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates': 'accountId', 'GET /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]': 'accountId' | 'certificateId', 'DELETE /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]': 'accountId' | 'certificateId', 'POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/activate': 'accountId' | 'certificateId', 'POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/deactivate': 'accountId' | 'certificateId', 'POST /api/accounts/[accountId]/cloudflare-sdk/gateway/certificates/[certificateId]/turn-on': 'accountId' | 'certificateId', 'POST /api/cloudflare-sdk/graphql': never, 'GET /api/itunes/search': never, 'POST /api/profile/lock': never, 'POST /api/profile/locking-mechanism/encrypt-password': never, 'POST /api/profile/pin-request': never, 'POST /api/profile/pin-request/verify': never, 'POST /api/profile/secondary-email': never, 'POST /api/profile/secondary-email/verify': never, 'POST /api/profile/unlock': never, 'POST /api/profile/validate/[mechanismType]': 'mechanismType', 'GET /api/device-config/download/[deviceConfigId]': 'deviceConfigId', 'prerender /api/device-config/registry/[platform]/[osId]/[category].json': 'platform' | 'osId' | 'category', 'entries /api/device-config/registry/[platform]/[osId]/[category].json': 'platform' | 'osId' | 'category', 'GET /api/device-config/registry/[platform]/[osId]/[category].json': 'platform' | 'osId' | 'category', 'GET /auth/callback': never, 'GET /auth/confirm': never, 'GET /download/[accountId]/cloudflare/certificates': 'accountId', 'GET /download/[accountId]/cloudflare/certificates/[certificateId]': 'accountId' | 'certificateId', 'GET /download/config/ios/presets': never, 'GET /download/config/macos/presets': never, 'GET /logout': never, 'POST /qstash/[messageType]': 'messageType', 'prerender /static-cache/dns-app/traffic-log-filter.json': never, 'GET /static-cache/dns-app/traffic-log-filter.json': never, 'prerender /static-cache/dns-content-category/traffic-log-filter.json': never, 'GET /static-cache/dns-content-category/traffic-log-filter.json': never, 'POST /webhooks/stripe': never, 'POST /webhooks/supabase': never, 'GET /webhooks/supabase': never, 'POST /webhooks/supabase/cloudflare/locations': never, 'GET /webhooks/supabase/cloudflare/locations': never, 'POST /webhooks/supabase/events': never, 'GET /webhooks/supabase/events': never }
  ACTIONS: { 'update /[accountId]/settings/cloudflare': 'accountId', 'create /[accountId]/settings/cloudflare/networks/location': 'accountId', 'update /[accountId]/settings/cloudflare/networks/location': 'accountId', 'delete /[accountId]/settings/cloudflare/networks/location': 'accountId', 'accept /profile/invites/[inviteId]': 'inviteId' }
  LINKS: { 'profileLocking': never, 'deviceSetup': never, 'installConfigFilesOnIOS': never, 'installConfigFilesOnMac': never, 'uninstallConfigFilesOnMac': never, 'uninstallConfigFilesOnIOS': never, 'deviceConfigReleaseBlog': never, 'freeGuideAppleShortcuts': never }
  Params: { 'accountId': never, 'price': never, 'returnUrl': never, 'type': never, 'freeTrial': never, 'session_id': never, 'ruleId': never, 'focus': never, 'tab': never, 'auto': never, 'id': never, 'redirect': never, 'redirectUrl': never, 'configId': never, 'showTutorial': never, 'inviteId': never, 'slug': never, 'referer': never, 'locationId': never, 'certificateId': never, 'mechanismType': never, 'deviceConfigId': never, 'responseType': never, 'action': never, 'timestamp': never, 'platform': never, 'osId': never, 'category': never, 'messageType': never }
}
